(function() {
'use strict';

angular
  .module('app.myPolls')
  .controller('ViewCollectionController', ViewCollectionController);
    
ViewCollectionController.$inject = [
  '$log', 
  '$anchorScroll',
  '$mdDialog',
  '$mdToast',
  '$scope',
  '$state',
  '$stateParams',
  'metrics',
  'shell', 
  'myPollsService'
];
  
function ViewCollectionController(
    $log, 
    $anchorScroll,
    $mdDialog,
    $mdToast,
    $scope, 
    $state, 
    $stateParams, 
    metrics,
    shell, 
    myPollsService
  ) {
  $log = $log.getInstance('ViewCollectionController');
  
  /* jshint validthis: true */
  var vm = this;
  
  vm.addGroup = addGroup;
  vm.collection = null;
  vm.deleteGroup = deleteGroup;
  vm.editGroup = editGroup;
  vm.editPolls = editPolls;
  vm.exportResults = exportResults;
  vm.filteredGroups = null;
  vm.groups = null;
  vm.isUpcoming = isUpcoming;
  vm.reorderGroup = reorderGroup;
  vm.saveTimeout = null;
  vm.shell = shell;
  vm.toggleUpcoming = toggleUpcoming;
  vm.viewResult = viewResult;
  vm.groupHasPolls = groupHasPolls;
  
  activate();
  
  function activate() {
    myPollsService.getCollection($stateParams.collectionId)
      .then(_setCollection);
  }
  
  function addGroup() {
    $mdDialog.show({
      fullscreen: true,
      templateUrl: 'app/my-polls/collections/add-group.html',
      controller: 'AddGroupController as vm',
      clickOutsideToClose: true,
      locals: { collection: vm.collection }
    }).finally(function(){
      // Set the collection again so that changes are reflected in vm.
      _setCollection(vm.collection);
    })
    // temp fix for https://github.com/angular/material/issues/10369
    .catch(angular.noop);
  }
  
  function archiveCollection() {
    var collection = vm.collection;
    return metrics.log('dialog ArchiveCollection')
      .then(function() {
        return $mdDialog.show(
          $mdDialog.marsConfirm({
            locals: {
              title: 'Archive Collection',
              content: 'Archiving a collection will remove it from the left side menu but you can still access it from the Archive.',
              ok: 'Archive',
              cancel: 'Cancel'
            }
          })
        )
      })
      .then(function() { metrics.log('archive collection'); })
      .then(function() {
        myPollsService.archiveCollection(collection);
        $state.go('shell.myPolls.upcoming');
      })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
  }
  
  function cloneCollection() {
    return metrics.log('dialog CloneCollection')
      .then(function() {
        return $mdDialog.show({
          fullscreen: true,
          templateUrl: 'app/my-polls/collections/clone-collection.html',
          controller: 'CloneCollectionController as vm',
          clickOutsideToClose: true,
          locals: { collection: vm.collection }
        })
      })
      .then(function() { metrics.log('clone collection'); })
      // temp fix for https://github.com/angular/material/issues/10369
      .catch(angular.noop);
  }

  function collectionExportResults() {
    exportResults(vm.collection.groups);
  }
  
  function deleteCollection() {
    var collection = vm.collection;
    $mdDialog.show(
      $mdDialog.marsConfirm({
        locals: {
          title: 'Send to Trash',
          content: 'Are you sure you want to send ' + collection.name + ' to Trash?',
          ok: 'Trash',
          cancel: 'Cancel'
        }
      })
    ).then(function() {
      myPollsService.deleteCollection(collection, collection.groups.length === 0);
      $state.go('shell.myPolls.upcoming');
    })
    // temp fix for https://github.com/angular/material/issues/10369
    .catch(angular.noop);
  }
  
  function deleteGroup(group) {
    var indexOfDeleted = vm.groups.indexOf(group)
    vm.groups.splice(indexOfDeleted, 1);
    var filteredIndex = vm.filteredGroups.indexOf(group);
    if (filteredIndex >= 0)
      vm.filteredGroups.splice(filteredIndex, 1);
    myPollsService.deleteGroup(group);

    $mdToast.show($mdToast.simple()
      .textContent('Group Sent to Trash')
      .action('UNDO')
      .highlightAction(true)
      .position('bottom right')
    ).then(function(response) {
      if ( response === 'ok' ) {
        myPollsService.restoreGroup(group);
        vm.groups.splice(indexOfDeleted, 0, group);
        if (filteredIndex >= 0)
          vm.filteredGroups.splice(filteredIndex, 0, group);
      }
    });
  }
  
  function editCollection() {
    $mdDialog.show({
      templateUrl: 'app/my-polls/collections/edit-collection.html',
      controller: 'EditCollectionController as vm',
      clickOutsideToClose: true,
      locals: { collection: vm.collection }
    }).finally(function() {
      // Set the collection again so that changes are reflected in vm.
      _setCollection(vm.collection);
    });
  }
  
  function editGroup(group) {
    $mdDialog.show({
      templateUrl: 'app/my-polls/collections/edit-group.html',
      controller: 'EditGroupController as vm',
      clickOutsideToClose: true,
      locals: { group: group }
    }).finally(function() {
      // Set the collection again so that changes are reflected in vm.
      _setCollection(vm.collection);
    })
    // temp fix for https://github.com/angular/material/issues/10369
    .catch(angular.noop);
  }
  
  function editPolls(group, jumpToAddPoll) {
    $state.go('shell.myPolls.collections.editPolls', { 
      collectionId: group.collection._id,
      groupId: group._id,
      jumpToAddPoll: jumpToAddPoll
    });
  }
  
  function exportResults(groups) {
    if (!angular.isArray(groups))
      groups = [groups];
    $mdDialog.show({
      fullscreen: true,
      templateUrl: 'app/my-polls/collections/export-results.html',
      controller: 'ExportResultsController as vm',
      clickOutsideToClose: true,
      locals: { groups: groups }
    })
    // temp fix for https://github.com/angular/material/issues/10369
    .catch(angular.noop);
  }
  
  function isUpcoming(group) {
    return group.upcoming !== null && group.upcoming <= new Date();
  }

  function groupHasPolls(group) {
    return _.some(group.polls, function(p) {
      return p.deleted === null || p.deleted === undefined
    })
  }
  
  function leaderboard() {
    $state.go('shell.myPolls.collections.leaderboard', { 
      collectionId: vm.collection._id 
    });
  }

  function manageCollaborators() {
    $mdDialog.show({
      fullscreen: true,
      templateUrl: 'app/my-polls/collections/manage-collaborators.html',
      controller: 'ManageCollaboratorsController as vm',
      clickOutsideToClose: true,
      locals: { collection: vm.collection }
    })
    // temp fix for https://github.com/angular/material/issues/10369
    .catch(angular.noop);
  }
  
  function reorderGroup(fromIndex, toIndex) {
    if (toIndex < 0 || toIndex >= vm.groups.length)
      return;
    var group1 = vm.groups[fromIndex],
        group2 = vm.groups[toIndex];
    myPollsService.swapGroups(group1, group2);
    vm.groups[fromIndex] = group2;
    vm.groups[toIndex] = group1;
    $anchorScroll('group-' + toIndex);
  }
  
  function saveTimeoutCallback() {
    myPollsService.updateCollection(vm.collection, 'groups');
  }
  
  function toggleUpcoming(group) {
    group.upcoming = isUpcoming(group) ? null : new Date();
    myPollsService.updateGroup(group, 'upcoming')
      .then(function() { metrics.log(group.upcoming ? 'pin' : 'unpin'); });
  }

  function viewResult(poll) {
    $log.debug('viewResult: ', poll._id);
    var resultCallback = function(result) {
      $state.go('result', { resultId: result._id, mode: 'live' });
    };
    return myPollsService.getLastResult(poll)
      .then(resultCallback)
      .catch(function(err) {
        if (err.code && err.code === 404)
          return myPollsService.createResult(poll).then(resultCallback);
      });
  }
  
  
  function _searchCallback(phrase) {
    vm.filteredGroups = myPollsService.searchGroups(vm.groups, phrase);
  }
  
  function _setCollection(collection) {
    shell.setTitle(collection.name);
    shell.setSearch(_searchCallback);
    shell.setMenu([
      { 
        label: 'Leaderboard', 
        callback: leaderboard, 
        icon: 'format_list_numbered'
      },
      { 
        label: 'Export Results', 
        callback: collectionExportResults, 
        icon: 'file_download'
      },
      { 
        label: 'Manage Collaborators', 
        callback: manageCollaborators, 
        icon: 'person_add' 
      },
      { 
        label: 'Clone Collection', 
        callback: cloneCollection, 
        icon: 'control_point_duplicate'
      },
      {
        label: 'Archive Collection', 
        callback: archiveCollection, 
        icon: 'archive'
      },
      { 
        label: 'Send Collection to Trash', 
        callback: deleteCollection, 
        icon: 'delete' 
      }
    ], 'Feed Code: ' + collection.token);
    vm.collection = collection;
    vm.groups = _.filter(collection.groups, function(group) {
      return !angular.isDate(group.deleted);
    });
    _searchCallback(); // Populate vm.filteredGroups
  }
  
}

})();